<style scoped>
.section-items h4 {
  line-height: 20px;
}
</style>
<template>
  <layout name="LayoutDefault">
    <div class="Authors">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">

            <div
                v-for="(item, k) in publishers"
                :key="k"
                class="col-lg-2 col-sm-6 col-6 section-item publishers"
                >
                <a :href="`${baseUrl}publisher/${item.id}`">
                    <div class="author-img-holder">
                        <img
                        v-if="item.image"
                        :src="`${IMAGEURL}/publisher/${item.image}`"
                        title="Image Loading..."
                        />     
                        <img
                        v-else
                        src="/assets/img/placeholder/publishers.png"
                        title="Image Loading..."
                        />
                    </div>
                    <h4>{{ item.publisher_name }}</h4>
                </a>
                </div>

          </div>
        </div>
      </div>
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";

export default {
  data() {
    return {
      loading: true,
      publishers: true,
    };
  },
  components: {
    Layout,
    "vue-load-image": VueLoadImage
  },
  methods: {
    getPublishers() {
      this.$http
        .get("publishers-resources")
        .then(response => {
          this.publishers = response.data.data;
        })
        .catch(e => {
          this.publishers = null;
        });
    }
  },
  mounted() {
    this.getPublishers();
  }
};
</script>
